import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = {
      push: (path) => {
        navigate(path);
      },
      goBack: () => {
        window.history.back();
      },
      listen: (listener) => {
        const unlisten = props.history.listen(listener);
        return unlisten;
      },
    };

    return React.createElement(Component, {
      ...props,
      location, history,
      match: { params },
      customRouter: { location, history, params },
    });
  }

  return ComponentWithRouterProp;
}